export const correctCarData = {
  buttons: [
    {
      label: 'Yes',
      id: 'yes',
    },
    {
      label: 'No, search again',
      id: 'no',
    },
  ],
  title: 'Is this your car?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/af2f32fa7d8a-tooliconcarquestion.jpg',
  },
}
